import { ProductType } from "@commons-monorepo/index";
import { UiButton } from "@ui-monorepo/index";
import { QuantityManager } from "../../components/quantity-manager";
import { useProductSelector } from "../../product-selector.hook";
import { ProductSelectorProps } from "../../product-selector.types";

export const ProductSelectorSkin1 = ({
  product,
  theme,
  cartProducts,
  addProduct,
  removeProduct,
  manuallyChangeProduct,
  selectedToppings,
  offerId,
  disable,
  ...props
}: ProductSelectorProps) => {
  const { t, hasProductInTheCart, hasDisabled, handleBuyButtonClick } =
    useProductSelector({
      ...props,
      product,
      selectedToppings,
      offerId,
      cartProducts,
      removeProduct,
      manuallyChangeProduct,
      theme,
      addProduct,
    });

  return (
    <div>
      {hasProductInTheCart ? (
        <QuantityManager
          product={product}
          addProduct={addProduct}
          cartProducts={cartProducts}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          selectedToppings={selectedToppings}
          offerId={offerId}
          theme={theme}
        />
      ) : (
        <UiButton
          disabled={disable || hasDisabled}
          isFilled
          rightIcon={
            <span
              className={
                product.type === ProductType.Service
                  ? "icon-calendar"
                  : theme.config.button?.icon || "icon-cart"
              }
            />
          }
          onClick={() => handleBuyButtonClick()}
        >
          {t(
            product.type === ProductType.Service
              ? "button.service"
              : "button.add",
          )}
        </UiButton>
      )}
    </div>
  );
};
